import { createClient } from "@supabase/supabase-js";

// 2026-07-13 — runtime env resolution.
// Priority: window.__ENV (set by public/index.html's inline bootstrap, whose
// placeholders entrypoint.sh substitutes at container start) > process.env
// (build-time inline, kept for `npm start` local dev).
//
// If the placeholders were NOT substituted (local dev, or entrypoint didn't
// run) they still contain the literal `__RUNTIME_…__` sentinel — we detect
// that and treat it as "not set" so the process.env fallback wins.
const isPlaceholder = (v) => typeof v === "string" && v.startsWith("__RUNTIME_") && v.endsWith("__");
const pick = (runtime, buildtime) => {
  if (runtime && !isPlaceholder(runtime)) return runtime;
  return buildtime;
};

const RUNTIME = (typeof window !== "undefined" && window.__ENV) || {};

const SUPABASE_URL = pick(RUNTIME.SUPA_URL, process.env.REACT_APP_SUPA_URL);
const SUPABASE_PUBLISHABLE_KEY = pick(RUNTIME.SUPA_PUBLISHABLE, process.env.REACT_APP_SUPA_PUBLISHABLE);

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "Missing Supabase env vars: set SUPA_URL + SUPA_PUBLISHABLE in Cloud Run " +
    "(Variables & Secrets), or REACT_APP_SUPA_URL + REACT_APP_SUPA_PUBLISHABLE " +
    "in .env for local dev."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// ── CORS preflight (perf note, Epic 9) ──────────────────────────────────
// RPC calls are POST + application/json + apikey → each unique request shape
// triggers an OPTIONS preflight. The browser caches that preflight for the
// duration the SERVER returns in `Access-Control-Max-Age`. That header is a
// Supabase/PostgREST *response* header — it CANNOT be set from the browser
// (request headers don't influence it). So the frontend perf levers are:
//   1. fire all panel RPCs in one Promise.all (parallel → the browser
//      coalesces concurrent identical preflights instead of staircasing them);
//   2. resolve auth once (this client is a singleton — no per-request auth);
//   3. one small `guest_intel_sentences` read shared across all panels.
// To raise the preflight cache to a full day (86400s) set
// `Access-Control-Max-Age: 86400` on the Supabase project's CORS config
// (dashboard / `pg_settings`) — that is a backend/infra task, not frontend.
